import { useEffect } from 'react'

import { actionsSelector, useStore } from '@liveHelper/models/store'

import { useRrwebClientContext } from '@core/rrweb'

/**
 * Sets actions that need access to the rrweb module.
 */
export const useSetMonitoringActions = () => {
  const { rrweb } = useRrwebClientContext()

  const { removeMonitoringActions, setMonitoringActions } =
    useStore(actionsSelector)

  useEffect(() => {
    if (rrweb) {
      setMonitoringActions({
        takeFullSnapshot: () => {
          rrweb.record.takeFullSnapshot()
        },
      })

      return () => {
        removeMonitoringActions()
      }
    }
  }, [rrweb, setMonitoringActions, removeMonitoringActions])
}
